module.exports = __webpack_public_path__ + "static/media/vol.f8c316d6.jpg";